import React, {useEffect} from 'react'
import {Switch,  Route, useHistory, Redirect} from 'react-router'

const NewQualifiedPipelineComponent = () => {

    const history = useHistory();

    useEffect(  () => {
        (async () => {
          await  localStorage.setItem('skygeni-user-page', 'Rep Performance')
          await  localStorage.setItem('skygeni-user-repPage', "New Qualified pipeline")
          await  localStorage.removeItem('skygeni-user-enhancedPage')
            history.push('/')
            window.location.reload()
        })();   
    },[])

    return (
        <div style={{ margin: "1rem auto" }}>Loading...</div>)
    }
   


export default NewQualifiedPipelineComponent;